

const singleSimDetailType = {


    START_FETCHING_SINGLE_SIM_DETAILS:"START_FETCHING_SINGLE_SIM_DETAILS",
    SUCCESS_FETCHIED_SINGLE_SIM_DETAILS:"SUCCESS_FETCHIED_SINGLE_SIM_DETAILS",
    FAILURE_FETCHED_SINGLE_SIM_DETAILS:"FAILURE_FETCHED_SINGLE_SIM_DETAILS",

    START_FETCHING_QUIZ_DETAILS:"START_FETCHING_QUIZ_DETAILS",
    SUCCESS_FETCHIED_QUIZ_DETAILS:"SUCCESS_FETCHIED_QUIZ_DETAILS",
    FAILURE_FETCHED_QUIZ_DETAILS:"FAILURE_FETCHED_QUIZ_DETAILS",

    START_FETCHING_EXERCISE_DETAILS:"START_FETCHING_EXERCISE_DETAILS",
    SUCCESS_FETCHIED_EXERCISE_DETAILS:"SUCCESS_FETCHIED_EXERCISE_DETAILS",
    FAILURE_FETCHED_EXERCISE_DETAILS:"FAILURE_FETCHED_EXERCISE_DETAILS",


}

export default singleSimDetailType

